// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3mDcF","footer":"ReportModalFilter_footer__TYiqc"};